var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8216 16.6078C25.6346 15.6729 24.8138 15 23.8604 15H7.13961C6.18625 15 5.36542 15.6729 5.17845 16.6078L3.47845 25.1078C3.23093 26.3454 4.17752 27.5 5.43961 27.5H25.5604C26.8225 27.5 27.7691 26.3454 27.5216 25.1078L25.8216 16.6078ZM23.45 17.5L23.95 20H16.75V17.5H23.45ZM14.25 17.5V20H7.05L7.55 17.5H14.25ZM6.55 22.5H14.25V25H6.05L6.55 22.5ZM16.75 25V22.5H24.45L24.95 25H16.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 12.5V11.25C16.75 10.5596 16.1904 10 15.5 10C14.8096 10 14.25 10.5596 14.25 11.25V12.5C14.25 13.1904 14.8096 13.75 15.5 13.75C16.1904 13.75 16.75 13.1904 16.75 12.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7411 9.00635L22.8572 8.12247C22.369 7.63432 21.5776 7.63432 21.0894 8.12247C20.6013 8.61062 20.6013 9.40207 21.0894 9.89022L21.9733 10.7741C22.4615 11.2622 23.2529 11.2622 23.7411 10.7741C24.2292 10.2859 24.2292 9.4945 23.7411 9.00635Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14861 8.12336L7.26473 9.00724C6.77658 9.49539 6.77658 10.2868 7.26473 10.775C7.75289 11.2631 8.54433 11.2631 9.03248 10.775L9.91636 9.89111C10.4045 9.40296 10.4045 8.61151 9.91636 8.12336C9.42821 7.63521 8.63676 7.63521 8.14861 8.12336Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.5H5.5C4.80964 2.5 4.25 3.05964 4.25 3.75C4.25 4.44036 4.80964 5 5.5 5H6.75C7.44036 5 8 4.44036 8 3.75C8 3.05964 7.44036 2.5 6.75 2.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 2.5H24.25C23.5596 2.5 23 3.05964 23 3.75C23 4.44036 23.5596 5 24.25 5H25.5C26.1904 5 26.75 4.44036 26.75 3.75C26.75 3.05964 26.1904 2.5 25.5 2.5Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.75C18.95 8.75 21.75 5.95 21.75 2.5H19.25C19.25 4.5625 17.5625 6.25 15.5 6.25C13.4375 6.25 11.75 4.5625 11.75 2.5H9.25C9.25 5.95 12.05 8.75 15.5 8.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPv);
export default __webpack_public_path__ + "static/media/PV.efecca33f6f81bcc2bf54cee6f64458c.svg";
export { ForwardRef as ReactComponent };